<template>
  <div class="panel panel-default version-card">
    <div class="panel-heading clearfix">
      <div class="row">
        <div tabindex="0" class="col-md-6 header-title">
          <h3><b>Recent Projects</b></h3>
        </div>
        <div class="col-md-6 text-right mt-10 pr-20">
          <button @click="directToProjects" class="btn btn-default btn-md view-btn">
            View All
          </button>
        </div>
      </div>
    </div>
    <div class="panel-body mb-5 ml-10 mr-10" :class="{ 'pb-0': recentProjects.length > 0 }">
      <div class="row">
        <template v-if="isLoading">
          <div class="loading-container">
            <loader class="loader">
              <p slot="text">Loading...</p>
            </loader>
          </div>
        </template>
        <template v-else>
          <div class="col-md-12 pr-0">
            <template v-if="recentProjects.length === 0">
              <div class="row border-style">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-10 col-md-offset-1 pl-0 pr-0 empty-project text-center">
                      <span
                        ><em
                          >Create your first project! Click the green "New Project" button, or start
                          with a Featured Project.</em
                        ></span
                      >
                      <div class="mt-20">
                        <router-link
                          :tag="'button'"
                          class="btn btn-lg btn-success mat ml-10"
                          :to="{ name: 'new-version' }"
                        >
                          <span class="fas fa-plus-circle mr-5"></span> New Project</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <table class="table">
                <thead>
                  <tr>
                    <th tabindex="0" scope="col">Project Name</th>
                    <th tabindex="0" scope="col">Last Edit</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="proj in recentProjects" :key="proj.versionKey">
                    <td tabindex="0" class="pr-20">
                      <div class="row pl-15 table-text">
                        <template v-if="proj.isActive">
                          <span class="fas fa-badge-check text-success mt-5"></span>
                        </template>
                        <span tabindex="0" class="table-text">{{ proj.versionName }}</span>
                      </div>
                    </td>
                    <td tabindex="0" class="last-edit-td">
                      <div class="row pl-15 table-text">
                        <p class="edit-text">{{ proj.lastEdit }}</p>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="row pl-15 table-text" v-if="hasParticipants(proj.versionKey)">
                        <router-link
                          :class="['edit-text']"
                          style="text-decoration: underline;"
                          :to="{
                            name: 'participant-results',
                            params: { resourceKey: proj.versionKey },
                          }"
                        >
                          View Results</router-link
                        >
                      </div>
                    </td>
                    <td class="edit-btn-td">
                      <!-- <div class="row pl-15 table-text pull-right">
                        <router-link
                          :class="['edit-text']"
                          :to="{
                            name: 'participant-results',
                            params: { resourceKey: proj.versionKey },
                          }"
                        >
                          View Results</router-link
                        >
                      </div> -->

                      <div class="btn-group pull-right pr-10">
                        <router-link
                          :class="['btn btn-sm btn-primary edit-btn']"
                          tag="button"
                          :disabled="proj.isActive ? true : false"
                          :to="{ name: 'skills', params: { resourceKey: proj.versionKey } }"
                        >
                          <span class="fas fa-pencil"></span> Edit</router-link
                        >
                        <button
                          class="btn btn-sm btn-primary dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                        >
                          <span class="fas fa-ellipsis-v"></span>
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-select" @click="handlePublish(proj)" href="#">
                              <i class="fa fa-rocket"></i> Publish</a
                            >
                          </li>
                          <li>
                            <a class="dropdown-select" @click="handleCopy(proj.versionKey)" href="#"
                              ><i class="fas fa-copy"></i> Copy</a
                            >
                          </li>
                          <li>
                            <a class="dropdown-select" @click="handleShare(proj)" href="#">
                              <i class="fas fa-share"></i> Share</a
                            >
                          </li>
                          <template v-if="!proj.isActive">
                            <li>
                              <a class="dropdown-select" @click="handleDelete(proj)" href="#"
                                ><i class="fas fa-trash-alt"></i> Delete</a
                              >
                            </li>
                          </template>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </template>
      </div>
    </div>
    <modal id="confirm-delete-version" :show-footer="false">
      <h3 class="m-0" slot="title">Delete Version</h3>
      <div slot="body" class="text-center">
        <p>Are you sure you want to delete "{{ selectedVersion.versionName }}"?</p>
        <button @click="handleConfirmDelete(selectedVersion.versionKey)" class="btn btn-danger mat">
          Confirm
        </button>
      </div>
    </modal>
    <publish :from-recent-project="true" :version-key="selectedVersion.versionKey" />
    <share-version-modal
      id="share-version-modal"
      :version-name="selectedVersion.versionName"
      :versionKey="selectedVersion.versionKey"
    />
    <share-version-modal
      id="share-version-modal"
      :version-name="selectedVersion.versionName"
      :versionKey="selectedVersion.versionKey"
    />
  </div>
</template>
<script>
  import Publish from '../VersionList/Publish';
  import ShareVersionModal from '../VersionList/ShareVersionModal.vue';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import Loader from '@shared/loader.vue';
  export default {
    name: 'RecentProjects',
    data() {
      return {
        selectedVersion: {},
      };
    },
    components: {
      Publish,
      ShareVersionModal,
      Loader,
    },
    methods: {
      ...mapActions('versions', ['duplicateVersion', 'deleteVersion', 'getAllRecentProjects']),
      directToProjects() {
        this.$router.push({ name: 'projects' });
      },

      handleDelete(proj) {
        this.selectedVersion = proj;
        $('#confirm-delete-version').modal('show');
      },

      async handleConfirmDelete(versionKey) {
        await this.deleteVersion({ versionKey });
        this.selectedVersion = {};
        await this.getAllRecentProjects({ authorKey: this.actorKey });
        $('#confirm-delete-version').modal('hide');
      },

      handlePublish(proj) {
        this.selectedVersion = proj;
        $('#publish-version').modal({ backdrop: 'static', keyboard: false });
      },
      async handleCopy(versionKey) {
        await this.duplicateVersion({ versionKey });
        await this.getAllRecentProjects({ authorKey: this.actorKey });
      },
      handleShare(version) {
        this.selectedVersion = version;
        $('#share-version-modal').modal('show');
      },
      hasParticipants(versionKey){
        const test = this.authorProjects.find(e=>e.versionKey == versionKey)
        return test?.participantCount > 0
      }
    },
    computed: {
      ...mapGetters('versions', ['recentProjects', 'isLoading']),
      ...mapState('versions', ['authorProjects']),
      ...mapState('user', ['actorKey']),
    },
  };
</script>
<style lang="scss" scoped>
  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dropdown-select {
    padding-left: 20px;
    height: 30px;
  }

  .dropdown-menu {
    min-width: 110px;
  }
  .empty-project {
    margin-top: 30px;
  }

  .version-card {
    height: auto;
  }

  .edit-btn-td {
    width: 22%;
  }

  .panel-heading {
    border: 0px solid transparent;
  }

  .loading {
    color: gray;
  }

  .header-title {
    margin-top: -10px;
  }

  .view-btn {
    width: 90px;
    margin-top: -4px;
  }

  @media (min-height: 1080px) {
    .panel-body {
      padding-top: 0;
      min-height: 278px;
    }

    .border-style {
      margin-left: -9px;
      margin-right: 9px;
      height: 265px;
      padding-top: 5vh;
    }
  }

  @media (min-height: 900px) and (max-height: 1079px) {
    .panel-body {
      padding-top: 0;
      min-height: 278px;
    }
    .border-style {
      margin-left: -9px;
      margin-right: 9px;
      height: 265px;
      padding-top: 5vh;
    }
  }

  @media (max-height: 899px) and (min-height: 769px) {
    .panel-body {
      padding-top: 0;
      min-height: 280px;
    }
    .border-style {
      margin-left: -9px;
      margin-right: 9px;
      height: 265px;
      padding-top: 5vh;
    }
  }

  @media (min-height: 750px) and (max-height: 768px) {
    .panel-body {
      padding-top: 0;
      min-height: 270px;
    }

    .border-style {
      margin-left: -9px;
      margin-right: 9px;
      height: 265px;
      padding-top: 5vh;
    }
  }

  @media (min-height: 720px) and (max-height: 749px) {
    .panel-body {
      padding-top: 0;
      min-height: 345px;
    }

    .border-style {
      margin-left: -9px;
      margin-right: 9px;
      height: 325px;
      padding-top: 5vh;
    }
  }

  .table,
  .border-style {
    border: 1px solid lightgray;
  }
  .table {
    margin-left: -9px;
  }

  .edit-text {
    font-size: 12px;
    padding-top: 5px;
  }

  .edit-btn {
    width: 60px;
  }

  .dropdown-toggle,
  .edit-btn {
    margin-top: 3px;
  }

  .table-text {
    margin-top: 5px;
  }

  @media only screen and (max-width: 1366px) {
    .edit-btn-td {
      width: 30%;
    }
    .empty-project {
      margin-top: 50px;
    }
  }
  @media only screen and (max-width: 1594px) and (min-width: 1367px) {
    .edit-btn-td {
      width: 24%;
    }
  }
  @media only screen and (max-width: 1651px) {
    .last-edit-td {
      width: 28%;
    }
  }
</style>
